export default "__VITE_PUBLIC_ASSET__c72e63d6__"